<div class="container">
    <div class="header-container">
      <h1 fxShow fxHide.lt-lg class="header-title">Refunds</h1>
    </div>
  </div>
  